import { ConfigProvider, App as AntApp } from 'antd';
import './styles/globals.scss';
import RoutesWrapper from './Routes';
import dayjs from 'dayjs';
import uts from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import 'react-phone-number-input/style.css';
import QueryProvider from './services/react-query';
import enUS from 'antd/locale/en_US';
import arEG from 'antd/locale/ar_EG';
import { IntlProvider } from 'react-intl';
import LangEn from './lang/en.json';
import LangAr from './lang/ar.json';
import enClients from './lang/enClients.json';
import arClients from './lang/arClients.json';
import enSales from './lang/enSales.json';
import arSales from './lang/arSales.json';
import arOverview from './lang/arOverview.json';
import enOverview from './lang/enOverview.json';
import arCatalog from './lang/arCatalog.json';
import enCatalog from './lang/enCatalog.json';
import arReports from './lang/arReports.json';
import enReports from './lang/enReports.json';
import arSettings from './lang/arSettings.json';
import enSettings from './lang/enSettings.json';
import enOnlineBooking from './lang/enOnlineBooking.json';
import arOnlineBooking from './lang/arOnlineBooking.json';
import enAuth from './lang/enAuth.json';
import arAuth from './lang/arAuth.json';
import { appTheme, appThemeEn } from './utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { setCurrentLang } from './services/store/slices/user';

dayjs.extend(duration);
dayjs.extend(uts);

function App() {
  const currentLang = useSelector((state) => state?.user?.currentLang);
  const currentUser = useSelector((s) => s?.user?.data);
  const isAdmin = currentUser?.user?.roles?.some((s) => s?.name === 'admin');
  const dispatch = useDispatch();
  const VERSION = '2.0.0';
  const validateMessages = {
    required: `الرجاء إدخال بيانات الحقل`,
  };
  useEffect(() => {
    localStorage.setItem('currentLang', currentLang || 'ar');
    document.getElementsByTagName('html')[0].setAttribute('lang', currentLang);
    if (isAdmin) {
      localStorage.setItem('currentLang', 'en');
      dispatch(setCurrentLang('en'));
      document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
    }
    console.log(currentLang, 'awwwww999');
  }, [currentLang, isAdmin]);

  useEffect(() => {
    checkVersion();
  }, []);

  const checkVersion = () => {
    const cachedVersion = localStorage.getItem('appVersion');
    if (cachedVersion) {
      if (cachedVersion !== VERSION) {
        // Clear the cache if versions don't match
        localStorage.clear();

        // Set the current version before reloading
        localStorage.setItem('appVersion', VERSION);

        // Reload the window
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    } else {
      localStorage.setItem('appVersion', VERSION);
    }
  };

  const isArabicLang = true;
  const messages =
    currentLang === 'en'
      ? {
          ...LangEn,
          ...enClients,
          ...enSales,
          ...enOverview,
          ...enCatalog,
          ...enSettings,
          ...enOnlineBooking,
          ...enReports,
          ...enAuth,
        }
      : {
          ...LangAr,
          ...arClients,
          ...arSales,
          ...arOverview,
          ...arCatalog,
          ...arSettings,
          ...arOnlineBooking,
          ...arReports,
          ...arAuth,
        };

  if (process.env.NODE_ENV === 'production') {
    console.log = function () {};
  }

  return (
    <QueryProvider>
      <IntlProvider
        locale={currentLang || 'ar'}
        defaultLocale="ar"
        messages={messages}
      >
        <ConfigProvider
          // direction="rtl"
          direction={currentLang === 'ar' ? 'rtl' : 'ltr'}
          locale={currentLang === 'en' ? enUS : arEG}
          theme={isArabicLang ? appTheme : appThemeEn}
          form={{ validateMessages, requiredMark: true }}
          virtual
        >
          <AntApp>
            <RoutesWrapper />
          </AntApp>
        </ConfigProvider>
      </IntlProvider>
    </QueryProvider>
  );
}

export default App;
